export default __webpack_public_path__ + "static/media/overleaf.e38c076c.jpg";